/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Controller,
} from 'react-hook-form';
import {
  ErrorBox,
  ErrorMessage,
  ErrorTitle,
  FormDialog,
  FormElement,
  FormInputsStack,
  FormDialogTitle,
  FormDialogContent,
  FormDialogActions,
  FormCancelButton,
  FormSubmitButton,
  Inputs,
  ComboBoxOption,
} from '@marageti/z4-lib';
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  TextField,

} from '@mui/material';
import { DestinationFormProps } from './types';

const DestinationForm = ({
  control,
  countryOptions,
  editorState,
  errors,
  handleSubmit,
  onCancel,
  onSubmit,
  open,
  register,
  submissionError,
}: DestinationFormProps) => {
  const isEditing = !!editorState?.id;

  return (
    <FormDialog open={open}>
      <FormDialogTitle handleClose={onCancel}>
        {isEditing ? `Edit ${editorState?.name}` : 'New Destination'}
      </FormDialogTitle>
      <FormElement name="edit-destination" onSubmit={handleSubmit(onSubmit)}>
        <FormDialogContent>
          <FormInputsStack>
            <Inputs.Text
              error={!!errors?.name}
              helperText={errors?.name?.message as string}
              id="name"
              label="Display name"
              required
              {...register('name', {
                required: 'Please enter a destination name',
              })}
            />
            <Controller
              key="countries"
              control={control}
              name="countries"
              rules={{
                validate: (value) => (value && value.length > 0) || 'Please select at least one country',
              }}
              render={({ field }) => (
                <Autocomplete
                  multiple
                  id="countries"
                  options={countryOptions}
                  getOptionLabel={(option: ComboBoxOption) => option.label}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  value={field.value || []}
                  onChange={(_, data) => {
                    field.onChange(data || []);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Countries"
                      error={!!errors?.countries}
                      helperText={errors?.countries?.message as string}
                      InputLabelProps={{ ...params.InputLabelProps, required: true }}
                    />
                  )}
                />
              )}
            />
            <Controller
              name="served"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={(
                    <Checkbox
                      {...field}
                      checked={field.value ?? true}
                      onChange={(e) => field.onChange(e.target.checked)}
                    />
                  )}
                  label="Active (available for new trip requests)"
                />
              )}
            />
          </FormInputsStack>
          {submissionError && (
            <ErrorBox>
              <ErrorTitle>There was an error on our end.</ErrorTitle>
              <ErrorMessage>
                {`Code: ${submissionError.code}: ${submissionError.message}`}
              </ErrorMessage>
            </ErrorBox>
          )}
        </FormDialogContent>
        <FormDialogActions>
          <FormCancelButton onClick={onCancel} sx={{ height: 42 }} />
          <FormSubmitButton sx={{ height: 42 }}>Submit</FormSubmitButton>
        </FormDialogActions>
      </FormElement>
    </FormDialog>
  );
};

export default DestinationForm;
